import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';

export default function OfflineBanner() {
  const { isOffline } = useOnlineStatus();

  if (!isOffline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-crm-warning-bg border-b border-crm-warning text-crm-warning-text text-xs font-medium text-center py-1.5 px-4 flex items-center justify-center gap-2"
    >
      <WifiOff className="w-3.5 h-3.5 flex-shrink-0" />
      <span>You are offline. Some features may be unavailable.</span>
    </div>
  );
}
